<h1 class="titulo">Home</h1>

<ng-container *ngIf="user?.esColaborador || user?.esMedico; else AdminTemplate">
  <app-reporte-detalle-saldos [IdUser]="user?.colaboradorId"></app-reporte-detalle-saldos>
</ng-container>

<!-- <ng-template #CheckRole3Template>
  <ng-container *ngIf="user?.esMedico; else AdminTemplate">
    <div class="bienvenido-container">
      <div class="bienvenido-card">
        <div class="bienvenido-icono">
          <img src="assets/icon/icono-sgmm.svg" alt="SGMM" class="icono-sgmm-bienvenido" />
        </div>
        <h1 class="bienvenido-texto">Bienvenido</h1>
        <p class="bienvenido-leyenda">
          Si tienes algún problema o necesitas asistencia, por favor contacta a un administrador del sistema.
        </p>
      </div>
    </div>
  </ng-container>
</ng-template> -->

<ng-template #AdminTemplate>
  <ng-container *ngIf="indice == 0">

    <nz-spin [nzSpinning]="loading" nzTip="Cargando..." class="loading-spinner">
    <div class="breadcrumb-container">
      <div class="breadcrumb-navigation">
        <span class="breadcrumb-item breadcrumb-home">Home</span>
        <i nz-icon nzType="right" class="breadcrumb-separator"></i>
        <span class="breadcrumb-item breadcrumb-current">Reporte Resumen de Gastos Médicos Menores y Comprobaciones</span>
      </div>
    </div>

                    <!-- <button 
                  nz-button 
                  nzType="default" 
                  nzSize="small"
                  (click)="visualizarInfo()"
                  nz-tooltip="Ver información del usuario"
                >
                  <i nz-icon nzType="user" nzTheme="outline"></i>
                </button> -->

        <div class="formulario_right">
          <button nz-button nzType="primary" class="excel-button" (click)="visualizarInfo()">
            <i nz-icon nzType="user" nzTheme="outline"></i>
            Visualizar mi información
          </button>
        </div>
    <!-- <div class="reporte-titulo">
      Reporte Resumen de Gastos Medicos Menores y Comprobaciones
    </div> -->
    <div class="tabla-principal">
      <div class="tabla-header-container">
        <div class="tabla-header-left">
          <span class="registros-label"
            >Registros: <strong>{{ filteredColaboradores.length }}</strong></span
          >
        </div>
        <div class="tabla-header-right">
          <button nz-button nzType="primary" class="excel-button" (click)="descargarExcel()" [disabled]="generarExcel">
            <i nz-icon nzType="file-excel" nzTheme="outline"></i>
            Generar Excel
          </button>
        </div>
      </div>
      
      <!-- Barra de búsqueda con ancho completo -->
      <div class="search-container search-input-full">
        <nz-input-group nzSuffixIcon="search" class="">
          <input 
            type="text" 
            nz-input 
            placeholder="Buscar por ID o Nombre.." 
            [(ngModel)]="searchText"
            (ngModelChange)="onSearchChange($event)"
          />
        </nz-input-group>
      </div>
      <div class="table-scroll-container">
      <nz-table
        #basicTable
        [nzData]="filteredColaboradores || []"
        class="tabla-colaboradores"
        nzSize="small"
      >
        <thead>
          <tr>
            <th class="col-acciones bold"></th>
            <th class="col-nombre bold">Colaborador</th>
            <th class="col-fecha-nacimiento bold">Fecha Nacimiento</th>
            <th class="col-sociedad bold">Sociedad</th>
            <th class="col-division bold">División</th>
            <th class="col-correo bold">Correo KOF</th>
            <th class="col-fecha-ingreso bold">Fecha de Alta del Beneficio</th>
            <th class="col-saldo bold">Saldo Total Anual</th>
            <th class="col-saldo bold">Saldo Comprobado</th>
            <th class="col-saldo bold">Saldo Pendiente</th>
          </tr>
        </thead>
        <tbody>
          <tr *ngFor="let item of basicTable.data">
            <td class="col-acciones">
              <div class="center-container">
                <img
                  src="assets/icon/detail.svg"
                  class="icono-sgmm"
                  style="cursor: pointer;"
                  alt="icono sgmm"
                  (click)="onAccionClick(item)"
                />
                <!-- <i
                  nz-icon
                  nzType="eye"
                  nzTheme="outline"
                  (click)="onAccionClick(item)"
                  style="cursor: pointer; color: #1890ff"
                ></i> -->
              </div>
            </td>
            <td class="col-nombre">
              {{ item?.nombres }} {{ item?.apellidos }}
              <div style="font-size: 12px; color: #888;">
                {{ item?.numeroEmpleado }}
              </div>
            </td>
            <td class="col-fecha-nacimiento">{{ item?.fechaNacimiento }}</td>
            <td class="col-sociedad">{{ item?.sociedadNombre }}</td>
            <td class="col-division">{{ item?.divisionNombre }}</td>
            <td class="col-correo">{{ item?.correoKof }}</td>
            <td class="col-fecha-ingreso">{{ item?.fechaAltaBeneficio }}</td>
            <td class="col-saldo">
              {{ item?.saldoTotal | currency : "MXN" : "symbol" : "1.2-2" }}
            </td>
            <td class="col-saldo">
              {{ item?.saldoUtilizado | currency : "MXN" : "symbol" : "1.2-2" }}
            </td>
            <td class="col-saldo">
              {{ item?.saldoRestante | currency : "MXN" : "symbol" : "1.2-2" }}
            </td>
          </tr>
        </tbody>
      </nz-table>
      </div>
    </div>
    </nz-spin>
  </ng-container>
  <ng-container *ngIf="indice == 1">
    <app-reporte-detalle-saldos
      [IdUser]="usuarioSeleccionado"
      (regresar)="regresar()"
    ></app-reporte-detalle-saldos>
  </ng-container>
</ng-template>
